import { AttachmentResponseInterface } from '../interfaces';
import { ListResponse } from '../interfaces/Shipment/ListResponseDto';
import api from './api';
import axios from 'axios';

const baseURL = process.env.REACT_APP_URL_PATH_API;

// Upload content files to DigitalOcean
export const uploadFileDO = async (
  file: File,
  entityID: number,
  attachmentTypeID: number,
  creationUser: string,
  identifierID?: string,
  attachmentDescription?: string,
  attachmentObservation?: string
): Promise<ListResponse<AttachmentResponseInterface>> => {
  let response: ListResponse<AttachmentResponseInterface> = {
    message: '',
    model: null,
    didError: true,
    errorMessage: '',
  };
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  const uri = `${baseURL}/Spaces`;
  const formData = new FormData();
  formData.append('File', file);
  formData.append('EntityID', entityID.toString());
  formData.append('AttachmentTypeID', attachmentTypeID.toString());
  formData.append('CreationUser', creationUser);
  if (identifierID) {
    formData.append('IdentifierID', identifierID);
  }
  if (attachmentDescription) {
    formData.append('AttachmentDescription', attachmentDescription);
  }
  if (attachmentObservation) {
    formData.append('AttachmentObservation', attachmentObservation);
  }

  try {
    const res = await api.post(uri, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      cancelToken: source.token,
    });
    if (res && res.status === 200 && res.data.didError === false) {
      return res.data;
    }
  } catch (error) {}
  response.errorMessage = 'Hubo un error al registrar el adjunto';
  return response;
};

// Update content files uploaded to DigitalOcean
export const updateFileDO = async (
  file: File,
  attachmentID: string
): Promise<ListResponse<boolean>> => {
  let response = {
    message: '',
    model: false,
    didError: true,
    errorMessage: '',
  };
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  const uri = `${baseURL}/Spaces`;
  const formData = new FormData();
  formData.append('File', file);
  formData.append('AttachmentID', attachmentID);

  try {
    const res = await api.put(uri, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      cancelToken: source.token,
    });
    if (res && res.status === 200 && res.data.didError === false) {
      return res.data;
    }
  } catch (error) {}
  response.errorMessage = 'Hubo un error al actualizar el adjunto';
  return response;
};

// Preview content files uploaded to DigitalOcean
export const previewFileDO = async (
  attachmentID: string
): Promise<ListResponse<AttachmentResponseInterface>> => {
  const uri = `${baseURL}/Attachment?attachmentID=${attachmentID}`;

  try {
    const response = await api.get(uri);

    if (
      response &&
      response.status === 200 &&
      response.data.didError === false
    ) {
      const data = response.data;
      const attachmentPath = data.model.attachmentPath;
      const fileExtension = attachmentPath.split('.').pop();

      try {
        // Usando fetch en lugar de axios
        const fileResponse = await fetch(attachmentPath);

        if (!fileResponse.ok) {
          throw new Error('No se pudo obtener el archivo');
        }

        const blob = await fileResponse.blob();
        const fileType =
          fileExtension === 'pdf' ? 'application/pdf' : 'image/png';
        const file = new Blob([blob], { type: fileType });

        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank', 'toolbar=0,location=0,menubar=0');

        return data; // Retorna data si todo sale bien
      } catch (error) {
        console.error('Error al obtener el adjunto:', error);
        return {
          message: '',
          model: null,
          didError: true,
          errorMessage: 'Hubo un error al obtener el adjunto de DigitalOcean',
        };
      }
    } else {
      // Si la respuesta no es válida (status !== 200 o didError === true)
      return {
        message: '',
        model: null,
        didError: true,
        errorMessage: 'La respuesta del servidor no fue exitosa',
      };
    }
  } catch (error) {
    console.error('Error al obtener la URL del adjunto:', error);
    return {
      message: '',
      model: null,
      didError: true,
      errorMessage:
        'Hubo un error al obtener el URL del adjunto en la base de datos',
    };
  }
};

// Delete content files uploaded to DigitalOcean
export const deleteFileDO = async (
  attachmentID: string
): Promise<ListResponse<boolean>> => {
  let response = {
    message: '',
    model: false,
    didError: true,
    errorMessage: '',
  };

  const uri = `${baseURL}/Spaces`;
  const body = {
    AttachmentID: attachmentID,
  };
  try {
    const res = await axios.delete(uri, { data: body });
    if (res && res.status === 200 && res.data.didError === false) {
      return res.data;
    }
  } catch (error) {}
  response.errorMessage = 'Hubo un error al eliminar el adjunto';
  return response;
};
